<template>
  <div v-if="ready" id="app">
    <router-view />
    <address-book-edit-popup />
  </div>
</template>

<script>

import AddressBookEditPopup from './components/protected/common/AddressBookEditPopup.vue'

export default {

  name: 'App',
  components: { AddressBookEditPopup },
  data () {
    return {
      ready: null
    }
  },

  async mounted () {
    await this.fetchDefaultWallet()
    await this.fetchDefaultGroup()
    await this.fetchAddressBooks()
    this.ready = true
  },
  methods: {
    async fetchAddressBooks () {
      var currentUrl = window.location.pathname
      if (!currentUrl.includes('/auth/login')) {
        const reply = await this.$accounts.get('/addressbook/user')
        this.$store.commit('USER_ADDRESS_BOOK', reply.data)
      }
    },

    async fetchDefaultWallet () {
      var currentUrl = window.location.pathname
      if (!currentUrl.includes('/auth/login')) {
        const reply = await this.$accounts.get('/users/default_wallet')
        this.$store.commit('SET_ACTIVE_WALLET', reply.data)
      }
    },

    async fetchDefaultGroup () {
      var currentUrl = window.location.pathname
      if (!currentUrl.includes('/auth/login')) {
        const reply = await this.$accounts.get('/users/default_group')
        if (reply.data.default_group_id) {
          const groupReply = await this.$api.get(`/groups/groups/${reply.data.default_group_id}`)
          this.$store.commit('SET_ACTIVE_GROUP', groupReply.data)
        }
      }
    }

  }
}

</script>

<style>
.bws-ico {
  width: 15px;
}
</style>
